import { Injectable, inject } from '@angular/core';
import { AuthHttpService } from './auth-http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AzureAuthService {
  private authService = inject(AuthHttpService);
  public authenticated: boolean;
  public user?: any;

  constructor() {
    this.authenticated = false;
    this.user = undefined;
  }

  isUserLogin() {
    return !this.authService.isAccessTokenExpired();
  }

  getTokenByAuthCode(): Observable<string> {
    return this.authService.signIn();
  }
}
